const getPreferenceCenterSmsNotAvailableInYourCountry = require("./getPreferenceCenterSmsNotAvailableInYourCountry");
const removeElement = require("../dom/removeElement");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function hidePreferenceCenterSmsNotAvailableInYourCountry(preferenceCenter) {
    const smsNotAvailable = getPreferenceCenterSmsNotAvailableInYourCountry(preferenceCenter);
    if (smsNotAvailable) {
        removeElement(smsNotAvailable);
    }
}